export function clientSidePagination(page: number, pageSize: number) {
  const start = page * pageSize
  const end = start + pageSize
  return [start, end]
}
